// Tooltip liviano (CSS hover, sin librería). Envuelve un trigger y muestra una
// etiqueta oscura al pasar el cursor. `group/tt` evita colisionar con otros group.

import type { ReactNode } from 'react';

export function Tooltip({
  label,
  side = 'top',
  children,
}: {
  label: string;
  side?: 'top' | 'bottom';
  children: ReactNode;
}) {
  const posCls =
    side === 'top'
      ? 'bottom-full mb-1.5'
      : 'top-full mt-1.5';
  return (
    <span className="relative inline-flex group/tt">
      {children}
      <span
        role="tooltip"
        className={`pointer-events-none absolute left-1/2 -translate-x-1/2 ${posCls} px-1.5 py-1 rounded-md bg-neutral-900 text-white text-[11px] font-medium leading-none whitespace-nowrap opacity-0 group-hover/tt:opacity-100 transition-opacity duration-150 z-[70] shadow-md`}
      >
        {label}
      </span>
    </span>
  );
}
